define('specific/footer/views/FooterView', [
    'specific/footer/templates/footer'
], function(tpl) {

    var FooterView = Mazarine.View.extend({

        events: {
            "change .js-maz-footer-countries": "onFooterCountriesChange"
        },

        template: tpl,

        className: "maz-footer-view",

        initialize: function() {

            this.on('render', this.afterRender);

        },

        render: function() {

            var options = {
                footerCountries: this.model.get('datas').countries,
                titleSelectCountries: this.model.get('datas').titleSelectCountries,
                mentions: this.model.get('datas').mentions,
                icp: this.model.get('datas').icp,
                rootLocale: this.model.get('config').locale
            };

            this.$el.html(this.template(options));
            this.trigger('render');
            return this.$el;

        },

        afterRender: function() {

            this.createCustomSelectFooter();

        },

        createCustomSelectFooter: function() {

            this.$('.maz-select-custom').mazCustomSelect({prefix: "maz", fixwidth: true, listClass: 'maz-custom-select-footer' });

        },

        onFooterCountriesChange: function( e ) {

            if ( $(e.currentTarget).find('option:selected').data('locale') !== '' ) {
                var urlCountry = $(e.currentTarget).find('option:selected').val();

                window.location.href = urlCountry;
            }

        }

    });

    return FooterView;
});
